import { LocalComponent } from "~/ecs/base"

export class SoundEffectEntered extends LocalComponent {}
